import { Container, BoxText, BoxImg } from "./style";
import ImgCarbon from "../../../../assets/img/Langding/ImgCarbon.png";

const CarbonFootprint = () => {
  return (
    <Container>
      <BoxText>
        <h1>
          Carbon <br /> Footprint
        </h1>
        <p>
          As seen from annual energy consumption the majority chunk of energy is
          consumed by Bitcoin which is being number 1 ranked currency on
          CoinMarketCap.
        </p>
        <p>
          Other related energy consumption being Running a exchange, hosting of
          NFT and meta verse related projects
        </p>
        <button>LET GO</button>
      </BoxText>
      <BoxImg>
        <img src={ImgCarbon} alt="" />
        <h1> Carbon Footprint</h1>
        <p>
          As seen from annual energy consumption the majority chunk of energy is
          consumed by Bitcoin which is being number 1 ranked currency on
          CoinMarketCap.
        </p>
        <p>
          Other related energy consumption being Running a exchange, hosting of
          NFT and meta verse related projects
        </p>
        <button>LET GO</button>
      </BoxImg>
    </Container>
  );
};
export default CarbonFootprint;


